import { render, staticRenderFns } from "./WorkflowReports.vue?vue&type=template&id=6243075e&scoped=true"
import script from "./WorkflowReports.vue?vue&type=script&lang=js"
export * from "./WorkflowReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243075e",
  null
  
)

export default component.exports